'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');
var ChangePasswordModalView = require('../modal/change-password');
var DeleteAccountModalView = require('../modal/delete-account');
var QuotaView = require('modules/settings/views/partials/quota');
var template = require('modules/settings/templates/layout/account.hbs');

var AccountLayout = LayoutView.extend({
    template: template,

    className: 'settings',

    /**
     * Collection for System languages
     * @type {SystemLanguagesCollection}
     */
    systemLanguagesCollection: null,

    /**
     * Collection for the countries
     * @type {CountriesCollection}
     */
    countriesCollection: null,

    ui: {
        updateAccount: '[data-action="update-account"]',
        deleteAccount: '[data-action="delete-account"]',
        changePassword: '[data-action="change-password"]',
        changeables: 'input,select',
        languageSelection: 'select[name="language"]',
        countrySelection: 'select[name="country"]',
    },

    events: {
        'click @ui.changePassword': 'changePassword',
        'click @ui.updateAccount': 'updateAccount',
        'click @ui.deleteAccount': 'deleteAccount',
        'change @ui.changeables': 'setSaveable',
        'keyup @ui.changeables': 'setSaveable',
    },

    regions: {
        quotaRegion: '.account-quota-region',
    },

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, options);
        this.systemLanguagesCollection = App.radio().request('system:languages:collection');
        this.countriesCollection = App.radio().request('countries:collection');
    },

    onShow: function() {
        this.quotaRegion.show(new QuotaView({
            model: App.user,
        }));

        // Listen for a language change
        this.listenTo(App.radio().vent, 'language:changed', function() {
            Messenger().post({
                type: 'success',
                message: App.t('settings::account:saveSuccess'),
            });
        }.bind(this));

        this.renderLanguageSelect();
        this.renderCountriesSelect();
    },

    setSaveable: function() {
        this.ui.updateAccount.prop('disabled', false);
    },

    changePassword: function() {
        App.addModal(new ChangePasswordModalView({
            item: App.user,
        }), {additionalClassName: 'modal-left modal-change-password'});

        return false;
    },

    deleteAccount: function() {
        App.addModal(new DeleteAccountModalView({
            item: App.user,
        }), {additionalClassName: 'modal-left modal-delete-account'});

        return false;
    },

    showLoading: function(element) {
        element.addClass('is-loading').prop('disabled', true);
    },

    hideLoading: function(element) {
        element.removeClass('is-loading').prop('disabled', false);
    },

    showSuccess: function(element) {
        Messenger().post({
            type: 'success',
            message: App.t('settings::account:saveSuccess'),
        });

        this.hideLoading(element);
    },

    showFail: function(element) {
        Messenger().post({
            type: 'error',
            message: App.t('settings::account:unknown-save-error'),
        });

        this.hideLoading(element);
    },

    updateAccount: function(event) {
        event.preventDefault();

        this.showLoading(this.ui.updateAccount);

        var attrs = {
            fullname: this.$('[name="name"]').val(),
            languageIso: this.$('[name="language"]').val(),
            country: this.$('[name="country"]').val(),
            countryIso: this.$('[name="country"]').val(),
            language: this.$('[name="language"]').val(),
            phone: this.$('[name="telefon"]').val(),
            address: this.$('[name="address"]').val(),
            address2: this.$('[name="address2"]').val(),
            zip: this.$('[name="zip"]').val(),
            city: this.$('[name="city"]').val(),
            notificationCompanyNews: this.$('[name="notificationCompanyNews"]:checked').length ? true : false,
            notificationProductUpdates: this.$('[name="notificationProductUpdates"]:checked').length ? true : false,
        };

        App.user.save(attrs, {
            patch: true,
            wait: true,
            success: function(model) {
                if (!this.isDestroyed) {
                    this.showSuccess(this.ui.updateAccount);
                    this.ui.updateAccount.prop('disabled', true);
                }
            }.bind(this),
            error: function() {
                if (!this.isDestroyed) {
                    this.showFail(this.ui.updateAccount);
                }
            }.bind(this),
        });
    },

    /**
     * Renders the selectfield for system languages
     */
    renderLanguageSelect: function() {
        // Return proper array
        var options = this.systemLanguagesCollection.map(function(model) {
            return {
                value: model.get('code'),
                label: App.t('global::lang-' + model.get('code')),
            };
        });

        // Render field
        this.renderSelectField({
            holder: this.ui.languageSelection,
            list: options,
            selected: function(data, item) {
                return this.model.get('language') === data.value;
            }.bind(this),
            placeholder: App.t('settings::account:language:please-choose'),
        });
    },

    /**
     * Renders the selectfield for the countries
     */
    renderCountriesSelect: function() {
        this.renderSelectField({
            holder: this.ui.countrySelection,
            list: this.countriesCollection,
            key: 'code',
            label: 'name',
            selected: function(data, model) {
                return this.model.get('country') === data.value;
            }.bind(this),
            placeholder: App.t('settings::profile:country:please-choose'),
        });
    },
});

module.exports = AccountLayout;